exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--cardFooter__NNdoT{font-size:15px;padding:7px;border-top:1px solid #e3e4e8}\n", ""]);

// exports
exports.locals = {
	"cardFooter": "styles--cardFooter__NNdoT"
};